import { useMemo } from 'react'

import i18n from 'modules/core/lib/i18n'

import { useIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

export interface SyncStateTranslations {
  syncing: string
  outdated: string
  synced: string
  pending: string
  failed: string
}

export const useSyncStateTranslations = (): SyncStateTranslations => {
  const { capabilityMode } = useIntegrationsSyncContext()
  const isExportMode = capabilityMode === 'file'

  return useMemo(() => {
    if (isExportMode) {
      return {
        syncing: i18n.t('integrations.exportable_status.exporting'),
        outdated: i18n.t('integrations.exportable_status.outdated'),
        synced: i18n.t('integrations.exportable_status.exported'),
        pending: i18n.t('integrations.exportable_status.pending'),
        failed: i18n.t('integrations.exportable_status.failed'),
      }
    }

    return {
      syncing: i18n.t('integrations.syncable_status.syncing'),
      outdated: i18n.t('integrations.syncable_status.outdated'),
      synced: i18n.t('integrations.syncable_status.synced'),
      pending: i18n.t('integrations.syncable_status.pending'),
      failed: i18n.t('integrations.syncable_status.failed'),
    }
  }, [isExportMode])
}
